import React from "react";
import { AccordionDescriptionContent } from "./styles";

interface IProps {
  content: JSX.Element | string;
  open: boolean;
  children?: JSX.Element | null;
  className?: string;
}
export default function AccordionDescription({
  content,
  open,
  children = null,
}: IProps): JSX.Element {
  return (
    <AccordionDescriptionContent role="contentinfo" isOpen={open}>
      {content}
      {children}
    </AccordionDescriptionContent>
  );
}
